import React from "react";
import { useSelector } from "react-redux";
import CmsPage from "../../../components/common/CmsPage";

export default function Terms() {
  const { user } = useSelector((state) => state.merchant);

  const role = user?.role || "user";

  const pageKey =
    role === "merchant"
      ? "terms_and_conditions_merchant"
      : "terms_and_conditions_user";

  return <CmsPage pageKey={pageKey} title="Terms & Conditions" />;
}
